export default "__VITE_ASSET__Blk9QIU6__"